import React from 'react';
import { AritoIcon, AritoFormV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { useSearchFieldStates } from '../hooks/useSearchFieldStates';
import { initialValues, searchSchema } from '../schemas';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import { Button } from '@/components/ui/button';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = (data: BanHangPayload) => {
    const combinedData = {
      ...data, // FormField data từ schema

      // DetailsTab SearchField data
      ma_khach_hang: searchFieldStates.customer?.uuid || '',
      nh_kh1: searchFieldStates.customerGroup1?.uuid || '',
      nh_kh2: searchFieldStates.customerGroup2?.uuid || '',
      nh_kh3: searchFieldStates.customerGroup3?.uuid || '',
      rg_code: searchFieldStates.region?.uuid || '',
      ma_vt: searchFieldStates.vatTu?.uuid || '',
      nh_vt1: searchFieldStates.vatTuGroup1?.uuid || '',
      nh_vt2: searchFieldStates.vatTuGroup2?.uuid || '',
      nh_vt3: searchFieldStates.vatTuGroup3?.uuid || '',

      // OtherTab SearchField data
      ma_gd: searchFieldStates.transaction?.uuid || '',
      tk_vat_tu: searchFieldStates.accountVatTu?.uuid || '',
      tk_doanh_thu: searchFieldStates.accountDoanhThu?.uuid || '',
      tk_gia_von: searchFieldStates.accountGiaVon?.uuid || '',
      ma_lo: searchFieldStates.lot?.uuid || '',
      ma_vi_tri: searchFieldStates.location?.uuid || ''
    };
    onSearch(combinedData);
    onClose();
  };

  const handleFormSubmit = () => {
    // Trigger form submit
    const form = document.querySelector('form');
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Báo cáo tổng hợp bán hàng thuần'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button className='bg-main text-white hover:bg-main-dark' onClick={handleFormSubmit}>
            <AritoIcon icon={884} />
            <span className='ml-1'>Đồng ý</span>
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} />
            <span className='ml-1'>Huỷ</span>
          </Button>
        </>
      }
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab searchFieldStates={searchFieldStates} />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab searchFieldStates={searchFieldStates} />
                }
              ]}
            />
          </div>
        }
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
